import { render, staticRenderFns } from "./JobFitting.vue?vue&type=template&id=5320d040&"
import script from "./JobFitting.vue?vue&type=script&lang=js&"
export * from "./JobFitting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports